import * as React from "react";
import * as ReactDOM from "react-dom";

export class ToolBarSeparator extends React.Component
{
    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        return <div className="toolbar_separator"></div>;
    }
}